/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import Selection from './Selection';
import constants from './constants';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  top: 50%;\n  left: 0;\n  height: ", ";\n  margin-top: -4px;\n  background-repeat: repeat-x;\n  border-radius: 5px;\n  border-color: ", ";\n  width: 100%;\n  background-color: ", ";\n  ", ";\n"], ["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  top: 50%;\n  left: 0;\n  height: ", ";\n  margin-top: -4px;\n  background-repeat: repeat-x;\n  border-radius: 5px;\n  border-color: ", ";\n  width: 100%;\n  background-color: ",
    ";\n  ", ";\n"])), function (props) { return constants[props.size].trackHeight; }, function (_a) {
    var theme = _a.theme;
    return theme.track.borderColor;
}, function (_a) {
    var theme = _a.theme, alarm = _a.alarm;
    return alarm ? theme.track.alarmbg : theme.track.bg;
}, function (props) { return props.onMouseDown && 'cursor: pointer'; });
Root.defaultProps = {
    theme: defaultTheme,
};
// tslint:disable-next-line
var noop = function () { };
var Track = /** @class */ (function (_super) {
    __extends(Track, _super);
    function Track() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Track.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, selectionWidth = _a.selectionWidth, _b = _a.size, size = _b === void 0 ? 'medium' : _b, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onTouchEnd = _a.onTouchEnd, onTouchStart = _a.onTouchStart, trackRef = _a.trackRef, _c = _a.alarm, alarm = _c === void 0 ? false : _c, _d = _a.warning, warning = _d === void 0 ? false : _d, _e = _a.success, success = _e === void 0 ? false : _e;
        return (React.createElement(Root, { warning: warning, success: success, alarm: alarm, size: size, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, ref: trackRef },
            React.createElement(Selection, { alarm: alarm, warning: warning, success: success, disabled: disabled, width: selectionWidth, size: size })));
    };
    Track.defaultProps = {
        size: 'medium',
        alarm: false,
        warning: false,
        success: false,
        onMouseDown: noop,
        onMouseUp: noop,
        onTouchEnd: noop,
        onTouchStart: noop,
    };
    Track.Selection = Selection;
    return Track;
}(React.Component));
export default Track;
var templateObject_1;
//# sourceMappingURL=Track.js.map